import React, { Component } from 'react';
import { RESTExecutor, withDomains } from '../lib/domain';
import { Spin, Row, Statistic, Badge, Divider, Icon, Typography, Menu, Descriptions, Col, Tag, Tooltip, Affix, Popover, Button, message, Modal, Select, Dropdown, Collapse, Tabs, Anchor, Table, Popconfirm } from 'antd';
import { formatMoney, showErrorInNotification, schema_to_field, overrideHeaderTitle, copyStringToClipboard } from '../lib/util';
import ErrorWrapper from '../lib/error_wrapper';
import TransactionPeersBatchReconcile from './transaction_peers_batch_reconcile';
import { PopUpForm } from '../lib/ui/popupform';
import CommentPage from './comment_page';
import { Close, BookmarksOutlined, FilterNone, LayersOutlined } from '@material-ui/icons';
import { COLORS } from '../pages/theme';
import { CustomStats, CustomStatsSmall } from './custom_stat';
import { TabButton } from './basic_items';
import { BasicHeader } from './basic_header';
import { Link } from 'react-router-dom';
const { TabPane } = Tabs;
const { Panel } = Collapse;
const queryString = require('query-string');

const { Title, Text, Paragraph } = Typography;
const MAX_RECON_SHOW = 5;
const MAX_RECON_ITEM_WIDTH = 200;
class ModalTransactionDetail extends Component {
    constructor(props) {
        super(props)

        this.transaction_id = this.props.match.params.transaction_id;

        this.state = {
            transaction_detail: {},
            loading: true,
            selected_rule: null,
            flag_data: {
                flags: []
            },
            flag_form_visibility: false,
            active_reconciler_index: null,
            selected_action_id: null,
            action_schema: [],
            action_data: {}
        }
        this.get_transactiondetail = RESTExecutor.list().config({
            label: 'transactiondetail'
        }).forId(this.transaction_id).callbacks((success) => {
            this.list_transaction_actions.forId(success.result.data_type_id).execute()

            this.setState({
                transaction_detail: success.result,
                loading: false
            })
        }, (error) => {
            this.setState({
                loading: false
            })
        }).connect(props.domains.allData);

        this.flag_transaction = RESTExecutor.post().config({
            label: 'flag_transaction'
        }).callbacks((success) => {
            message.success("Transaction Label Updated");
            this.get_transactiondetail.execute();
            this.setState({
                flag_form_visibility: false,
                flag_data: {
                    flags: []
                }
            })
        }, (error) => {
            showErrorInNotification(error)
        }).connect(props.domains.allData);

        this.run_action = RESTExecutor.post().config({
            label: 'action_transaction',
            params: {}
        }).callbacks((success) => {
            message.success("Action Run Successful");
            this.get_transactiondetail.execute();
            this.setState({
                selected_action_id: null,
                action_data: {},
                action_schema: []
            })
        }, (error) => {
            showErrorInNotification(error);
        }).connect(props.domains.allData);

        this.list_transaction_actions = RESTExecutor.list().config({
            label: 'datatype_actions'
        }).connect(props.domains.allData);

        this.remove_reconciler = RESTExecutor.delete().config({
            label: 'remove_reconciler',
            params: {

            }
        }).callbacks((success) => {
            this.get_transactiondetail.execute();
            message.success("Removed Successfully")
        }, (error) => {
            showErrorInNotification(error);
            this.setState({ loading: false })
        }).connect(props.domains.allData);

        this.remove_all_reconciler = RESTExecutor.delete().config({
            label: 'remove_all_reconciler',
            params: {

            }
        }).callbacks((success) => {
            this.get_transactiondetail.execute();
            message.success("Removed All Processor Successfully")
        }, (error) => {
            showErrorInNotification(error);
            this.setState({ loading: false })
        }).connect(props.domains.allData);

        this.add_reconciler = RESTExecutor.post().config({
            label: 'add_reconciler',
            params: {

            }
        }).callbacks((success) => {
            this.get_transactiondetail.execute();
            message.success("Added Successfully")
        }, (error) => {
            showErrorInNotification(error);
            this.setState({ loading: false })
        }).connect(props.domains.allData);


        this.get_transactiondetail.execute();
    }


    render() {
        const { loading, transaction_detail, active_reconciler_index } = this.state;
        if (loading) return <center><Spin /></center>

        let flags = transaction_detail.flags || {};
        let applied_actions = transaction_detail.applied_actions || {};

        let flag_transaction_resp = this.flag_transaction.response();
        let list_transaction_actions_resp = this.list_transaction_actions.response();
        let run_action_resp = this.run_action.response()
        let available_actions = (list_transaction_actions_resp.result && list_transaction_actions_resp.result.rows) || [];



        let reference = transaction_detail.__references__ || {};
        let data_type = reference.data_type_id || {};
        let service = reference.data_service_id || {};
        let reconciled_groups = (transaction_detail.reconciled_groups && transaction_detail.reconciled_groups.map((item) => {
            return {
                ...item,
                done: true
            }
        })) || [];
        let unreconciled_groups = (transaction_detail.unreconciled_groups && transaction_detail.unreconciled_groups.map((item) => {
            return {
                ...item,
                done: false
            }
        })) || [];
        let disabled_groups = (transaction_detail.deleted_groups && transaction_detail.deleted_groups.map((item) => {
            return {
                ...item,
                done: false,
                disabled: true
            }
        })) || [];
        let total_groups = [...reconciled_groups, ...unreconciled_groups, ...disabled_groups];
        let get_transactiondetail_resp = this.get_transactiondetail.response();


        let detail_grid = { xs: 24, sm: 24, md: 24, lg: 24, xl: 16, xxl: 16 };
        let comment_grid = { xs: 24, sm: 24, md: 24, lg: 24, xl: 8, xxl: 8 };




        return (
            <div
                style={{
                    // backgroundColor: 'white'
                }}>

                <PopUpForm
                    width="60%"
                    key={`${this.transaction_id}flag`}
                    title={"Flag Assigner"}
                    show_title_only
                    forCreate={true}
                    initialData={this.state.flag_data}
                    fields={[{ index: 'flags', name: "Labels", type: 'networkselect', url: `/my-data-types/${transaction_detail.data_type_id}/flags`, mode: 'multiple' }]}
                    open={this.state.flag_form_visibility}
                    networkState={flag_transaction_resp}
                    onClose={() => {
                        console.log("closing upload form")
                        this.setState({
                            flag_form_visibility: false,
                            flag_data: {
                                flags: []
                            }
                        })
                    }
                    }
                    onSubmit={(data) => {
                        console.log("DATA", data);
                        this.flag_transaction.forId(this.transaction_id).execute(data);
                    }}
                />
                <PopUpForm
                    width="60%"
                    key={`${this.transaction_id}action`}
                    title={"Run Action With"}
                    show_title_only
                    forCreate={true}
                    initialData={this.state.action_data}
                    fields={this.state.action_schema}
                    open={this.state.selected_action_id == null ? false : true}
                    networkState={run_action_resp}
                    onClose={() => {
                        console.log("closing upload form")
                        this.setState({
                            selected_action_id: null,
                            action_data: {},
                            action_schema: []
                        })
                    }
                    }
                    onSubmit={(data) => {
                        console.log("DATA", data);
                        this.run_action.config({
                            params: {
                                txn_id: this.transaction_id,
                                action_id: this.state.selected_action_id
                            }
                        }).execute({
                            run_params: data
                        })
                        // this.flag_transaction.forId(this.transaction_id).execute(data);
                    }}
                />
                <ErrorWrapper
                    no_back_action
                    error={get_transactiondetail_resp}
                    onReload={() => {
                        this.setState({ loading: true })
                        this.get_transactiondetail.execute()
                    }}
                >
                    <div className='default-card' style={{ padding: 0, margin: 0 }}>
                        <Row type='flex' justify='space-between' align='middle' style={{
                            flexWrap: 'nowrap',
                            padding: '20px 10px 10px'
                        }} >
                            <Row type='flex' style={{
                                flex: 1,
                                alignItems: 'center',
                                paddingLeft: 20,
                                paddingRight: 20,
                                // justifyContent: 'space-between',
                                paddingTop: 6,
                                paddingBottom: 6
                            }}>
                                <div style={{
                                    marginRight: 30
                                }}>
                                    <div title={transaction_detail.type == 'C' ? "Credit" : (transaction_detail.type == 'D' ? "Debit" : "N/A")} className={transaction_detail.type === 'D' ? 'debit-circle' : transaction_detail.type == 'C' ? 'credit-circle' : 'na-circle'}>
                                        {transaction_detail.type}
                                    </div>
                                </div>
                                <div style={{
                                    flex: 1
                                }}>
                                    <CustomStats label='TRANSACTION DATE' title={transaction_detail.txn_date} />
                                </div>
                                <div style={{
                                    flex: 1
                                }}>
                                    <CustomStats label='TRANSACTION ID' title={transaction_detail.transaction_id || "N/A"} />
                                </div> <div style={{
                                    flex: 1
                                }}>
                                    <CustomStats label='AMOUNT' title={formatMoney(transaction_detail.amount)} />
                                </div> <div style={{
                                    flex: 0.5
                                }}>
                                    <CustomStats label='PROCESSING STATUS' content={<div style={{
                                        display: 'flex', flexDirection: 'row',
                                        height: 36,
                                        lineHeight: '120%',
                                        alignItems: 'center'
                                    }}>
                                        {total_groups.map((item, index) => {
                                            return <Tooltip arrowPointAtCenter placement='bottomLeft' title={item.name} key={index} >
                                                <div className={item.done ? item.exclusion ? 'reconciled-indicator-with-exclusion' : 'reconciled-indicator' : 'not-reconciled-indicator'}></div></Tooltip>
                                        })}
                                    </div>} />
                                </div>
                            </Row>
                            <div style={{
                                width: 150,
                                paddingLeft: 20,
                                paddingRight: 20,
                                borderLeft: COLORS.border,
                                borderRight: COLORS.border,
                                height: '100%'
                            }}><Link to={{
                                pathname: `/activity/data-type/${transaction_detail.data_type_id}/packets`,
                                search: queryString.stringify({
                                    parse_batch_id: transaction_detail.parse_batch_id
                                })

                            }}>
                                    <div title='View Packets' className='hand-cursor' style={{ display: 'flex', flexDirection: 'row', alignItems: 'center' }}>
                                        <LayersOutlined style={{
                                            marginRight: 12,
                                            color: COLORS.black
                                        }} /> <span className='sub-heading-3'>View Packets</span>
                                    </div>
                                </Link>
                            </div>
                            <div style={{
                                width: 190,
                                paddingLeft: 20,
                                paddingRight: 20,
                                borderLeft: COLORS.border,
                                borderRight: COLORS.border,
                                height: '100%'
                            }}>
                                <div title='Copy ID' className='hand-cursor' onClick={() => {
                                    copyStringToClipboard(transaction_detail.id);
                                    message.success("Copied")
                                }} style={{ display: 'flex', flexDirection: 'row', alignItems: 'center' }}>
                                    <BookmarksOutlined style={{
                                        marginRight: 12
                                    }} /> <span className='sub-heading-3'>Copy ID to Clipboard</span>
                                </div>
                            </div>
                            {typeof this.props.onClose === 'function' &&
                                <div style={{
                                    width: 100,
                                    paddingLeft: 20,
                                    paddingRight: 20,
                                    height: '100%',
                                    display: 'flex',
                                    flexDirection: 'row',
                                    justifyContent: 'center'
                                }}>
                                    <Close className='hand-cursor' onClick={() => {
                                        if (typeof this.props.onClose === 'function') {
                                            this.props.onClose();
                                        } else {
                                            message.error("Please define onClose function")
                                        }
                                    }} />
                                </div>}
                        </Row>
                        <Divider style={{
                            marginTop: 0,
                            marginBottom: 12
                        }} />
                        <Row type='flex' style={{
                            paddingLeft: 20,
                        }}>
                            <span>
                                {transaction_detail.batch_id && <FilterNone
                                    className='batch-indicator'
                                    titleAccess="Batched"
                                    style={{
                                        marginRight: 8
                                    }}
                                />}
                                <span className='description-text'>{transaction_detail.description}</span>
                            </span>
                        </Row>
                        <Divider style={{
                            marginTop: 12,
                            marginBottom: 0
                        }} />
                        <Row type='flex'>
                            <Col {...detail_grid}>
                                <div style={{
                                    display: 'flex',
                                    // overflow:'auto',
                                    flexDirection: 'column',
                                    // padding: 8
                                    // height:'100%'
                                }}>
                                    {/* <Row type='flex' style={{
                                        paddingLeft: 40,
                                        paddingTop:12
                                    }}>
                                        <span>
                                            {transaction_detail.batch_id && <FilterNone
                                                className='batch-indicator'
                                                titleAccess="Batched"
                                                style={{
                                                    marginRight: 8
                                                }}
                                            />}
                                            <span className='description-text'>{transaction_detail.description}</span>
                                        </span>
                                    </Row>
                                    <Divider style={{
                                    marginTop: 12,
                                    marginBottom: 12
                                }} /> */}
                                    <Row type='flex' style={{
                                        paddingLeft: 20,
                                        justifyContent: 'space-between',
                                        paddingRight: 20,
                                        paddingTop: 12
                                    }}>
                                        <CustomStatsSmall label='DATATYPE' title={data_type.name || "N/A"} />
                                        <CustomStatsSmall label='SOURCE ID' title={transaction_detail.source_id} />
                                        <CustomStatsSmall label='SOURCE LABEL' title={transaction_detail.source_label} />
                                        <CustomStatsSmall label='SERVICE' title={service.name} />

                                    </Row>
                                    <Divider style={{
                                        marginTop: 12,
                                        marginBottom: 12
                                    }} />
                                    <Row style={{
                                        paddingLeft: 20,
                                        paddingRight: 20,
                                        flexWrap: 'wrap',
                                        paddingTop: 0,
                                        paddingBottom: 0,
                                        alignItems: 'center'
                                    }}>
                                        {Object.keys(flags).map((key) => {
                                            let flag = flags[key];
                                            return <Tag closable onClose={(e) => {
                                                e.preventDefault()
                                                let flags_ids = Object.keys(flags);
                                                let new_flags_id = flags_ids.filter((value) => value != key)
                                                this.flag_transaction.forId(this.transaction_id).execute({ flags: new_flags_id });
                                            }} className='tag-orange' style={{ marginRight: 6, marginBottom: 4 }}>{flag}</Tag>
                                        })}
                                        <Tag className='dashed-tag'
                                            onClick={() => {
                                                this.setState({
                                                    flag_form_visibility: true,
                                                    flag_data: {
                                                        flags: Object.keys(flags)
                                                    }
                                                })
                                            }}
                                            style={{ marginRight: 6, marginBottom: 4 }}>+ ADD LABELS</Tag>
                                    </Row>
                                    <Divider style={{
                                        marginTop: 12,
                                        marginBottom: 12
                                    }} />
                                    <Row style={{
                                        paddingLeft: 20,
                                        paddingRight: 20,
                                        flexWrap: 'wrap',
                                        paddingTop: 0,
                                        paddingBottom: 0
                                    }}>
                                        <span style={{ width: '100%', color: COLORS.secondary }}>Performed Actions:</span>
                                        {Object.keys(applied_actions).map((key) => {
                                            let action_name = applied_actions[key] || ""
                                            return <Tag
                                                title="Transaction Action"
                                                //  className='hand-cursor'
                                                className='tag-orange'
                                                //  color={COLORS.primary}
                                                style={{
                                                    marginRight: 6, marginBottom: 4
                                                }}>{action_name}</Tag>
                                        })}
                                        {Object.keys(applied_actions).length == 0 && <span style={{ opacity: 0.5 }}>No Actions Performed</span>}


                                    </Row>

                                    <Divider style={{
                                        marginTop: 12,
                                        marginBottom: 12
                                    }} />

                                    <Row style={{
                                        paddingLeft: 20,
                                        paddingRight: 20,
                                        flexWrap: 'wrap',
                                        paddingTop: 0,
                                        paddingBottom: 0
                                    }}>
                                        <span style={{ width: '100%', color: COLORS.secondary }}>Available Actions:</span>
                                        {list_transaction_actions_resp.fetching ? <Spin /> :

                                            available_actions.length > 0 ?
                                                available_actions.map((item) => {
                                                    return <Popconfirm title="Are you sure you want to run this transaction action?" onConfirm={() => {
                                                        if (Array.isArray(item.run_config) && item.run_config.length > 0) {
                                                            // require other params
                                                            this.setState({
                                                                action_schema: schema_to_field(item.run_config)
                                                            }, () => {
                                                                this.setState({
                                                                    selected_action_id: item.id
                                                                })
                                                            })
                                                        } else {
                                                            this.run_action.config({
                                                                params: {
                                                                    txn_id: this.transaction_id,
                                                                    action_id: item.id
                                                                }
                                                            }).execute()
                                                        }
                                                    }}><Tag
                                                        title="Transaction Action"
                                                        className='hand-cursor'
                                                        color={COLORS.primary}
                                                        style={{
                                                            marginRight: 6, marginBottom: 4
                                                        }}>{item.action_name}</Tag></Popconfirm>
                                                }) : <span style={{ opacity: 0.5 }}>No Any Actions Available</span>
                                        }
                                    </Row>

                                    <Divider style={{
                                        marginTop: 12,
                                        marginBottom: 0
                                    }} />

                                    <Row style={{
                                        paddingLeft: 6,
                                        paddingRight: 6
                                    }}>
                                        <Collapse className='customCollapse' accordion bordered={false} expandIconPosition='right'>
                                            <Panel header={<span className='sub-heading-3'>PARSED DATA</span>} key="1">
                                                {transaction_detail.parsed_data && Object.keys(transaction_detail.parsed_data).length > 0 &&
                                                    <Descriptions className='small-description' bordered size='small' layout='horizontal'>
                                                        {Object.keys(transaction_detail.parsed_data).map((key) => {
                                                            if (!key.startsWith('__')) {
                                                                return <Descriptions.Item key={key} label={key} className='log-text' >
                                                                    <Paragraph >
                                                                        {typeof transaction_detail.parsed_data[key] === 'string' ? transaction_detail.parsed_data[key] : JSON.stringify(transaction_detail.parsed_data[key])}
                                                                    </Paragraph>
                                                                </Descriptions.Item>

                                                            }
                                                        })}
                                                    </Descriptions>
                                                }
                                            </Panel>
                                        </Collapse>
                                    </Row>
                                    {transaction_detail.reconcile &&
                                        <React.Fragment>
                                            <Divider style={{
                                                marginTop: 0,
                                                marginBottom: 12
                                            }} />
                                            <div style={{
                                                paddingLeft: 20,
                                                paddingBottom: 12
                                            }}>
                                                <div style={{
                                                    display: 'flex',
                                                    flexDirection: 'row',
                                                    justifyContent: 'space-between'
                                                }}>
                                                    <span className='heading-2'>Processors</span>
                                                    {unreconciled_groups.length > 0 ? <Popconfirm
                                                        title="Are you sure you want to exclude all processor for this transaction?"
                                                        onConfirm={() => {
                                                            this.setState({ active_reconciler_index: null })
                                                            // }
                                                            this.setState({ loading: true })
                                                            console.log("removing id");
                                                            this.remove_all_reconciler.forId(this.transaction_id).execute();
                                                        }}
                                                    ><Button type='link' onClick={() => {
                                                    }}>
                                                            <div className='dangerText'> Exclude All</div>
                                                        </Button></Popconfirm> : null}
                                                </div>
                                                <Row type='flex' style={{ marginTop: 18 }}>
                                                    {total_groups.map((item, index) => {
                                                        return <TabButton
                                                            disabled={item.disabled}
                                                            onClick={() => {
                                                                if (!item.disabled) {
                                                                    this.setState({
                                                                        active_reconciler_index: index
                                                                    })
                                                                }
                                                                else {
                                                                    message.warn("Include this processor first")
                                                                }
                                                            }}
                                                            active={index === active_reconciler_index}
                                                            label={item.name}
                                                            type={item.done ? 'success' : 'error'}
                                                            className={item.exclusion ? 'success-with-exclusion' : ''}
                                                            style={{
                                                                marginRight: 12
                                                            }}
                                                            onRemove={item.done == true ? null : () => {
                                                                // if(active_reconciler_index==index){
                                                                this.setState({ active_reconciler_index: null })
                                                                // }
                                                                this.setState({ loading: true })
                                                                console.log("removing id");
                                                                this.remove_reconciler.config({
                                                                    params: {
                                                                        txn_id: this.transaction_id,
                                                                        reconciler_id: item.id
                                                                    }
                                                                }).execute();

                                                            }}
                                                            onAdd={item.disabled != true ? null : () => {
                                                                this.setState({ loading: true });

                                                                console.log("adding id")
                                                                this.add_reconciler.config({
                                                                    params: {
                                                                        txn_id: this.transaction_id,
                                                                        reconciler_id: item.id
                                                                    }
                                                                }).execute();
                                                            }}
                                                        />
                                                    })}
                                                </Row>
                                            </div>
                                            {active_reconciler_index != null && total_groups[active_reconciler_index] &&
                                                <div style={{
                                                    paddingLeft: 20,
                                                    paddingRight: 20,
                                                    backgroundColor: COLORS.main_bg_color,
                                                    paddingTop: 18,
                                                    paddingBottom: 18
                                                }}>
                                                    <TransactionPeersBatchReconcile
                                                        onRefresh={() => {
                                                            this.get_transactiondetail.execute()
                                                        }}
                                                        transaction_id={this.transaction_id}
                                                        amount={transaction_detail.amount}
                                                        batch_id={transaction_detail.batch_id}
                                                        reconciler_id={total_groups[active_reconciler_index].id}
                                                        reconciler={total_groups[active_reconciler_index]}
                                                        key={`${total_groups[active_reconciler_index].id}-${total_groups[active_reconciler_index].done}-${this.transaction_id}`}
                                                        reconciled={total_groups[active_reconciler_index].done}
                                                    />
                                                </div>
                                            }
                                            {/* <Tabs className='customTab' key="4">
                                                    {total_groups.map((item, index) => {
                                                        return <TabPane key={item.id} tab=
                                                            {
                                                                <TabButton label={item.name} type={item.done?'success':'error'}/>
                                                            // <Tooltip title={item.name} ><Badge className='faded-text-badge' style={{
                                                            //     maxWidth: MAX_RECON_ITEM_WIDTH,
                                                            //     whiteSpace: 'nowrap',
                                                            //     overflow: 'hidden',
                                                            //     textOverflow: 'ellipsis',
                                                            // }}
                                                            //     status={item.done ? 'success' : 'error'}
                                                            //     text={item.name} /></Tooltip>
                                                            }
                                                        >

                                                            <TransactionPeersBatchReconcile
                                                                onRefresh={() => {
                                                                    this.get_transactiondetail.execute()
                                                                }}
                                                                transaction_id={this.transaction_id}
                                                                amount={transaction_detail.amount}
                                                                batch_id={transaction_detail.batch_id}
                                                                reconciler_id={item.id}
                                                                reconciler={item}
                                                                key={`${item.id}-${item.done}-${this.transaction_id}`}
                                                                reconciled={item.done}
                                                            />
                                                        </TabPane>
                                                    })}
                                                </Tabs> */}
                                        </React.Fragment>
                                    }

                                </div>
                            </Col>
                            <Col {...comment_grid} style={{ borderLeft: '1px solid #ddd' }}>
                                <div style={{
                                    padding: 0
                                }}>

                                    <CommentPage
                                        rules_list={total_groups}
                                        dataID={this.transaction_id}
                                        key={`-${this.transaction_id}`}
                                    />
                                </div>

                            </Col>
                        </Row>
                        {/* <center><Link to={{
                            pathname:`/activity/data-type/${transaction_detail.data_type_id}/packets`,
                            search:queryString.stringify({
                                parse_batch_id:transaction_detail.parse_batch_id
                            })
                            
                        }}>Go to packet</Link></center> */}
                        {/* <div>
                                <Text strong style={{ display: 'inline' }}>Source:</Text> &nbsp;
                                    <Tag color='blue'>{transaction_detail.source_id}</Tag>
                            </div>
                            <div style={{
                                marginTop: 4, marginBottom: 4
                            }}>
                                <Text strong style={{ display: 'inline' }}>Description:</Text>  &nbsp;
                                        <Text>{transaction_detail.description}</Text>
                            </div>

                            <Row type='flex' justify='space-between'>
                                <div style={{
                                    display: 'flex',
                                    flexDirection: 'row',
                                    alignItems: 'center'
                                }}> <Tag> <Badge className='faded-text-badge' status='default' text={data_type.name || "Unknown Source"} />
                                    </Tag>
                                    <Tag style={{ display: 'flex' }} >
                                        <Badge className='faded-text-badge' color={service.color_code || 'grey'} text={service.name || "Unknown Service"} />
                                    </Tag>
                                   
                                </div>
                            </Row>

                            {transaction_detail.parsed_data && Object.keys(transaction_detail.parsed_data).length > 0 &&
                                <Descriptions title="Parsed Data" className='small-description' bordered size='small' layout='horizontal'>
                                    {Object.keys(transaction_detail.parsed_data).map((key) => {
                                        if (!key.startsWith('__')) {
                                            return <Descriptions.Item key={key} label={key} className='log-text' >
                                                <Paragraph>
                                                    {typeof transaction_detail.parsed_data[key] === 'string' ? transaction_detail.parsed_data[key] : JSON.stringify(transaction_detail.parsed_data[key])}
                                                </Paragraph>
                                            </Descriptions.Item>

                                        }
                                    })}
                                </Descriptions>
                            }
                            <div style={{
                                display: 'flex',
                                flexDirection: 'row',
                                width: '100%',
                                alignItems: 'center',
                                flexWrap: 'wrap',
                                paddingTop: 8
                            }} >
                                <label>Labels: &nbsp; </label>
                                {Object.keys(flags).map((key) => {
                                    let flag = flags[key];
                                    return <Tag color='geekblue' style={{ margin: 4 }}>{flag}</Tag>
                                })}
                                <Button type='link' onClick={() => {
                                    this.setState({
                                        flag_form_visibility: true,
                                        flag_data: {
                                            flags: Object.keys(flags)
                                        }
                                    })
                                }}>Update Labels</Button>
                            </div>
                        </div>
                        {transaction_detail.reconcile &&
                            <div className='default-card' style={{
                                padding: 8
                            }}>

                                <Tabs>
                                    {total_groups.map((item, index) => {
                                        return <TabPane key={item.id} tab=
                                            {<Tooltip title={item.name} ><Badge className='faded-text-badge' style={{
                                                maxWidth: MAX_RECON_ITEM_WIDTH,
                                                whiteSpace: 'nowrap',
                                                overflow: 'hidden',
                                                textOverflow: 'ellipsis',
                                            }}
                                                status={item.done ? 'success' : 'error'}
                                                text={item.name} /></Tooltip>}
                                        >

                                            <TransactionPeersBatchReconcile
                                                onRefresh={() => {
                                                    this.get_transactiondetail.execute()
                                                }}
                                                transaction_id={this.transaction_id}
                                                amount={transaction_detail.amount}
                                                batch_id={transaction_detail.batch_id}
                                                reconciler_id={item.id}
                                                reconciler={item}
                                                key={`${item.id}-${item.done}-${this.transaction_id}`}
                                                reconciled={item.done}
                                            />
                                        </TabPane>
                                    })}
                                </Tabs>

                            </div>
                        }

                        <div className='default-card' style={{ padding: 8 }}>
                        <CommentPage
                                    rules_list={total_groups}
                                    dataID={this.transaction_id}
                                    key={`-${this.transaction_id}`}
                                />
                        </div> */}

                    </div>
                </ErrorWrapper> </div>
        );
    }



    componentDidMount() {
        if (!this.props.isModal) {
            overrideHeaderTitle("")

        }
    }
    componentWillUnmount() {

    }
    componentDidUpdate = (prevProps) => {
        if (this.props.match.params.transaction_id !== prevProps.match.params.transaction_id) {
            this.transaction_id = this.props.match.params.transaction_id;
            this.setState({
                loading: true,
                active_reconciler_index: null
            })
            this.get_transactiondetail.forId(this.transaction_id).execute()
            // fetch the new product based and set it to the state of the component
        };
    }
}

export default ModalTransactionDetail = withDomains(ModalTransactionDetail, "allData");



const peers_cols = ({ onViewDetailClicked, onRemoveClicked }) => [
    {
        // title: "Type",
        dataIndex: "type",
        width: 50,
        key: 'type',
        render: (value) => <div style={{ backgroundColor: value == 'C' ? '#4062BB' : '#4E937A' }} className='dr-cr-text'>
            {value}
        </div>
    },
    {
        title: "Txn Date",
        dataIndex: "txn_date",
        width: 120,
        key: 'txn_date'
    }, {
        title: "Tran ID",
        dataIndex: "transaction_id",
        width: 100,
        key: 'transaction_id'
    }, {
        title: "Particular",
        dataIndex: "description",
        key: 'description'
    }, {
        title: "Amount",
        dataIndex: "amount",
        width: 120,
        key: 'amount',
        render: (amount = 0) => formatMoney(amount, 2, '.', ',')
    },
    {
        title: "",
        dataIndex: "id",
        width: 50,
        key: 'action',
        render: (id) => <span><Button type='link' onClick={() => {
            typeof onViewDetailClicked === 'function' && onViewDetailClicked(id)
        }}>View</Button>
            {/* <Divider type='vertical' />
            <Popconfirm title="Do you want to remove this peer?" onConfirm={() => {
                typeof onRemoveClicked === 'function' && onRemoveClicked(id)

            }}><Button style={{
                color: 'red'
            }} type='link' >Remove</Button></Popconfirm> */}
        </span>
    }
]